// D:\...\src\Prato-do-Dia\hojePage.js
import React, { useEffect, useState, useCallback } from "react";
import "./prato-do-dia.css";

const API_URL = "https://donnarosepratododia.com.br/listar_imagens.php";
const CACHE_KEY = "pratoDoDiaCache:v1";

function HojePage() {
  const [imagens, setImagens] = useState([]);
  const [atual, setAtual] = useState(0);
  const [fullscreenAtivo, setFullscreenAtivo] = useState(false);

  const aplicarLista = useCallback((urls) => {
    setImagens(urls);
    setAtual(0);
  }, []);

  const carregarDoCache = useCallback(() => {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      const parsed = raw && JSON.parse(raw);
      if (Array.isArray(parsed?.images)) aplicarLista(parsed.images);
    } catch {}
  }, [aplicarLista]);

  const buscarServidor = useCallback(async () => {
    try {
      const res = await fetch(API_URL, { cache: "no-store" });
      const data = await res.json();
      const urls = Array.isArray(data)
        ? data
        : Array.isArray(data?.images)
        ? data.images
        : [];
      if (urls.length) {
        aplicarLista(urls);
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ images: urls, savedAt: Date.now() })
        );
      }
    } catch (e) {
      console.error("Erro ao buscar imagens:", e);
    }
  }, [aplicarLista]);

  useEffect(() => {
    carregarDoCache(); // pinta instantâneo
    buscarServidor(); // atualiza em paralelo
  }, [carregarDoCache, buscarServidor]);

  // pré-carrega só os próximos 2 slides
  useEffect(() => {
    if (!imagens.length) return;
    const preload = (u) => {
      const i = new Image();
      i.src = u;
    };
    const n1 = imagens[(atual + 1) % imagens.length];
    const n2 = imagens[(atual + 2) % imagens.length];
    n1 && preload(n1);
    n2 && preload(n2);
  }, [atual, imagens]);

  // slideshow
  useEffect(() => {
    if (!imagens.length) return;
    const t = setInterval(
      () => setAtual((p) => (p + 1) % imagens.length),
      10000
    );
    return () => clearInterval(t);
  }, [imagens]);

  // recebe REFRESH_TV do uploader
  useEffect(() => {
    const handler = (ev) => {
      if (ev.origin !== window.location.origin) return;
      if (ev.data?.type === "REFRESH_TV") buscarServidor();
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [buscarServidor]);

  const entrarEmTelaCheia = async () => {
    try {
      const el = document.documentElement;
      if (el.requestFullscreen) await el.requestFullscreen();
      else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
      else if (el.msRequestFullscreen) el.msRequestFullscreen();
      setFullscreenAtivo(true);
    } catch {}
  };

  if (!imagens.length) {
    return (
      <div className="tv-container">
        <p className="tv-carregando">Carregando imagens...</p>
      </div>
    );
  }

  return (
    <div className="tv-container">
      <div className="tv-conteudo">
        {!fullscreenAtivo && (
          <button className="fullscreen-btn" onClick={entrarEmTelaCheia}>
            Entrar em Tela Cheia
          </button>
        )}
        <h1 className="tv-titulo">Prato do Dia | Donna Rose Marmitaria</h1>
        <img src={imagens[atual]} alt="Slide" className="tv-slide" />
      </div>
    </div>
  );
}
export default HojePage;
